import { subscriberIdApi } from '../../store';
import { formatSubscriberIdApiUrl } from '../../utils/formatApiUrl';
import { IFinanceChartResponse, subscriberIdFinanceMapping } from './mapping';
import { IFinanceChart } from './types';

export const financesApi = subscriberIdApi.injectEndpoints({
    endpoints: (builder) => ({
        getChartData: builder.query<IFinanceChart, string>({
            query: (subscriberId) => formatSubscriberIdApiUrl(subscriberId, 'finances'),
            transformResponse: (response: IFinanceChartResponse) => subscriberIdFinanceMapping(response),
        }),
    }),
});

export const {
    useGetChartDataQuery,
} = financesApi;
